export default __webpack_public_path__ + "static/media/blackArrow.b639a9b3.svg";